import {
  CommandelineEntity,
  GetProductsQuery,
  GetSingleProductQuery
} from '../../../graphql/generated/graphql';
import {
  ProductCategory,
  ProductMedia,
  ProductOnPanier,
  ProductTypes
} from '../../../types/product/product';

export const getProductMediaFromQuery: (
  medias: GetSingleProductQuery['produit']['data']['attributes']['media']['data']
) => ProductMedia[] = medias =>
  medias.map(m => ({
    url: m.attributes.url,
    name: m.attributes.name
  }));

export const getProductCategoriesFromQuery: (
  categories: GetSingleProductQuery['produit']['data']['attributes']['categorieproduits']['data']
) => ProductCategory[] = categories =>
  categories.map(c => ({
    id: c.id,
    name: c.attributes.name
  }));

export const getProductTypesFromQuery: (
  produit: GetSingleProductQuery['produit']['data']
) => ProductTypes = produit => ({
  ...produit?.attributes,
  ttcPrice: produit?.attributes?.ttcPrice,
  name: produit?.attributes?.name,
  categorieproduits: getProductCategoriesFromQuery(
    produit?.attributes?.categorieproduits?.data
  ),
  media: getProductMediaFromQuery(produit.attributes.media.data),
  id: produit.id
});

export const getProductDefFromQuery: (
  produit: GetProductsQuery['produits']['data'][0]
) => ProductOnPanier = produit => ({
  name: produit?.attributes?.name,
  id: produit?.id,
  ttcPrice: produit?.attributes?.ttcPrice,
  venterebond: produit?.attributes?.venterebond,
  media: getProductMediaFromQuery(produit?.attributes?.media?.data)
});

export const getProductOnPanierFromQuery: (
  produit: CommandelineEntity['attributes']['commande']['data']['attributes']['commandelines']['data'][0]['attributes']['produit']['data']
) => ProductOnPanier = produit => ({
  ...getProductDefFromQuery(produit),
  ref: produit?.attributes?.ref,
  media: produit?.attributes?.media?.data?.map(m => ({ url: m.attributes.url }))
});
